import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "material-symbols-outlined" }

type EquipmentType = {
  icon: string,
  type: string,
  name: string,
  path: string,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PeripheralEquipmentIcon',
  props: {
    equipment: {}
  },
  setup(__props: any) {

const props = __props


return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createTextVNode(_toDisplayString(props.equipment.icon) + " ", 1),
    _createVNode(_component_v_tooltip, {
      activator: "parent",
      location: "bottom"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(props.equipment.name), 1)
      ]),
      _: 1
    })
  ]))
}
}

})